import * as Yup from "yup";
//#region types
import { TranslationKeys } from "translations";
import { PeriodisationRowFormValue, PeriodisationRowsFormValue } from "models/formTypes/incomingInvoice";
//#endregion
import { PeriodisationRowsHelper } from "utils/helpers";

const isEmptyRow = (row: PeriodisationRowFormValue) => !row.range?.start && !row.range?.end && !row.amount;

/** Yup schema for a PeriodisationRowsFormValue: no range, one complete range, or split rows that cover the whole net. */
export const periodisationRowsSchema = (netAmount: number) =>
  Yup.mixed<PeriodisationRowsFormValue>()
    .test("periodisation-range-complete", TranslationKeys.Common.MustSelectDateRange, (value) => {
      if (!value) return true;
      const rows = value.rows ?? [];
      if (!value.isSplit)
        return rows.length === 0 || isEmptyRow(rows[0]) || PeriodisationRowsHelper.isRowComplete(rows[0]);
      return rows.every(PeriodisationRowsHelper.isRowComplete);
    })
    .test("periodisation-rows-cover-amount", TranslationKeys.Common.PeriodisationRowsMustCoverAmount, (value) => {
      if (!value || !value.isSplit) return true;
      const rows = value.rows ?? [];
      // Core compares positive row amounts against the absolute net, so credit invoices split the same way.
      if (rows.length === 0 || !rows.every((r) => (r.amount ?? 0) > 0)) return false;
      return PeriodisationRowsHelper.remaining(value, Math.abs(netAmount)) === 0;
    });
